import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { LoadingStateService, SchemaMembershipStateService, UserStateService } from '@net3-multiplatform-client/libs';
import { UserService } from 'apps/web/src/app/features/users/services/user.service';

export const schemaAccessGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
  const userState = inject(UserStateService);
  const userService = inject(UserService);
  const schemaState = inject(SchemaMembershipStateService);
  const router = inject(Router);
  const loadingService = inject(LoadingStateService)
  
  const schema = route.paramMap.get('id');
  if (!schema) {
    return router.parseUrl('/communities');
  }

  try {    
    loadingService.showLoadingPage.set(true);
    await userService.loadUserInfo(); // Assegura que userState tingui info    
    // les properties es carreguen aqui ja que es pot donar el cas en que el jwt no es valid, cosa que s'evalua en el loadUserInfo
    await schemaState.initializeSchemaProperties(schema)
  } catch {
    return router.parseUrl('/signin');
  }

  if(userState.hasAccessTo(schema)) return true

  return router.parseUrl('/error');
};